import { I18n } from '@kta20-core/interfaces/i-i18n';
import * as Constants from '@kta20-core/constants';
import {BaseModel} from "@kta20-core/models/base-model";

let _inst: I18nw;

export class I18nw implements I18n {

    private langISOCodes:string[]=['en','it']; //default always available

    //TODO: poor implementation that duplicated the language code, currently cannot change it since KT1 uses codes of 2 chars only (en,it) etc..
    private langISOCodesCountryCodes:string[]=['en-US','it-IT']; //default always available

    private userLang:string;

    static get(): I18nw {
        if (!_inst) _inst = new I18nw();
        return _inst;
    }

    constructor() {
        if (_inst) throw new Error(Constants.SINGLETON_CLASS);
    }

    getLanguage(): string {
        if(this.userLang)
            return this.userLang;

        //TODO: instead of calling directly the "navigator" object, use a proxy class
        // injected from client (navigator or else) so you can reduce the complexity
        // and keep one I18 service for both web and native
        this.userLang = navigator.language.split('-')[0];
        this.userLang = this.langISOCodes.includes(this.userLang) ? this.userLang : this.langISOCodes[0]; //en
        return this.userLang;
    }

    setLanguage(language:string) {
        if(this.langISOCodes.includes(language)) {
            this.userLang = language;
            BaseModel.setValidatorLanguage(this.getLanguageAndCountryCode());
        }
    }

    //TODO: invoke this method from kta20-ui-base module factory and pass languages from profile config json
    setSupportedLanguages(langISOCodes: string[],langISOCodesCountryCodes:string[]) {
        this.langISOCodes = langISOCodes;
        this.langISOCodesCountryCodes = langISOCodesCountryCodes;
        this.userLang = null; //to force refresh user language
    }

    getLanguageAndCountryCode(): string {
        return this.langISOCodesCountryCodes.find(lang=>lang.indexOf(`${this.getLanguage()}-`)!==-1);
    }

}
